module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 2017 by Marcus Wicker")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALL RIGHTS RESERVED")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Names: Wicker, Marcus, author.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Title: Silencer / Marcus Wicker.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Description: Boston : Mariner Books, 2017. | Description based on print version record and CIP data provided by publisher; resource not viewed. Identifiers: LCCN 2017014165 (print) | LCCN 2017016611 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9781328715586 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9781328715548 (paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Subjects: | BISAC: POETRY / American / African American. | POETRY / Inspirational & Religious. | POETRY / American / General. | HISTORY / Social History. | SOCIAL SCIENCE / Black Studies (Global).")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Classification: LCC PS3623.I268 (ebook) | LCC PS3623.I268 A6 2017 (print) | DDC 811/.6—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2017014165",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2017014165")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Book design by Mark R. Robinson")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("v1.0817")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2081d925","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0